<div class="main-banner" [style.background]="cover"
    [ngStyle]="{'height': '150px','background-size': 'cover','background-repeat': 'no-repeat','background-position': 'center'}">
</div>

<h2 class="p-2">{{greeting}}, {{_userinfo.UserName}}</h2>

<div class="px-1 mb-2 modules-container">
    <div class="row gap-2 justify-content-around flex-md-nowrap flex-sm-wrap mx-3">
        <screens-list class="card col-md-6 col-sm-12"
            [Title]="'RecentPages'|translate"
            [Items]="recentScreens"
            [ShowDeleteButton]="false"
            [IconPath]="'assets/icons/carbon--recently-viewed.svg'"
        ></screens-list>
        <screens-list class="card col-md-6 col-sm-12"
            [Title]="'FavoritePages'|translate"
            [Items]="favoriteScreens"
            [ShowDeleteButton]="true"
            [IconPath]="'assets/icons/iconamoon--star-fill.svg'"
        ></screens-list>
    </div>
    <div *ngIf="isSupervisor()">
        <app-dashboard></app-dashboard>
    </div>
    <div *ngIf="!isSupervisor()">
        <div class="modules px-2">
            <h4 class="m-2">Modules</h4>
            <div class="row">
                <ng-container *ngFor="let res of menuItemsService.items | slice:3">
                    <div class="col-md-3 col-sm-12" *ngIf="res.text && res.text !== 'Home'">
                        <div class="mb-2 module" (click)="navigateToPage(res.text)">
                            <img [src]="res.icon" [alt]="res.text">
                            <h6>{{res.text | translate }}</h6>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>